'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Venue = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _measurement = require('constants/measurement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Venue = exports.Venue = function (_PureComponent) {
  (0, _inherits3.default)(Venue, _PureComponent);

  function Venue() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, Venue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Venue.__proto__ || (0, _getPrototypeOf2.default)(Venue)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleRemoveClick = function (event) {
      event.stopPropagation();
      _this.props.onRemoveClick(_this.props.searchId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(Venue, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          subtitle = _props.subtitle,
          images = _props.images,
          distance = _props.distance,
          distanceUnit = _props.distanceUnit,
          highlighted = _props.highlighted,
          nameHighlighted = _props.nameHighlighted,
          locationName = _props.locationName,
          searchId = _props.searchId,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          onMouseMove = _props.onMouseMove,
          role = _props.role,
          ariaSelected = _props['aria-selected'],
          id = _props.id;

      var title = '' + nameHighlighted + (subtitle ? ' \xB7 ' + subtitle : '');

      return _react2.default.createElement(
        'li',
        {
          className: (0, _classnames2.default)('dropdown__item', {
            'dropdown__item--highlighted': highlighted
          }),
          id: id,
          onClick: onClick,
          onMouseDown: onMouseDown,
          onMouseMove: onMouseMove,
          role: role,
          'aria-selected': ariaSelected
        },
        images.smallVertical && _react2.default.createElement(
          'div',
          { className: 'dropdown__item__image-container' },
          _react2.default.createElement('img', { className: 'dropdown__item__image', src: images.smallVertical, alt: nameHighlighted }),
          _react2.default.createElement('div', { className: 'dropdown__item__image-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'dropdown__item__content' },
          _react2.default.createElement('span', {
            className: 'dropdown__item__label',
            dangerouslySetInnerHTML: { __html: title } // eslint-disable-line react/no-danger
          }),
          locationName && _react2.default.createElement(
            'span',
            { className: 'dropdown__item__sublabel' },
            distance ? _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'searchbox.venue.distanceToLocation',
              defaultMessage: '{distance} {distanceUnit} to {locationName}',
              values: { distance: distance, distanceUnit: distanceUnit, locationName: locationName }
            }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'searchbox.venue.location',
              defaultMessage: '{locationName}',
              values: { locationName: locationName }
            })
          )
        ),
        searchId && _react2.default.createElement(
          'div',
          { className: 'dropdown__item__remove', onClick: this.handleRemoveClick },
          'x'
        )
      );
    }
  }]);
  return Venue;
}(_react.PureComponent);

Venue.propTypes = {
  distance: _propTypes2.default.string,
  distanceUnit: _propTypes2.default.oneOf((0, _values2.default)(_measurement.DISTANCE_UNITS)).isRequired,
  highlighted: _propTypes2.default.bool.isRequired,
  images: _propTypes2.default.object.isRequired,
  locationName: _propTypes2.default.string.isRequired,
  nameHighlighted: _propTypes2.default.string.isRequired,
  onRemoveClick: _propTypes2.default.func.isRequired,
  searchId: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  'aria-selected': _propTypes2.default.bool.isRequired,
  id: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onMouseDown: _propTypes2.default.func.isRequired,
  onMouseMove: _propTypes2.default.func.isRequired,
  role: _propTypes2.default.string.isRequired
};